module.exports = __webpack_public_path__ + "img/inventer.4623a0ec.jpg";